import {
  MilestoneUserTypeOptionType,
  MilestoneRewardType,
  MilestoneInjectionTypeOptionType,
  MilestoneGeneralFormType,
} from 'features/Promotion/@types/MilestoneAddEdit'

export const userTypeOptions: MilestoneUserTypeOptionType[] = [
  {
    name: 'Early User',
    value: 'EARLY_USER',
  },
  {
    name: 'Global User',
    value: 'RETURNING_USER',
  },
]

export const injectionTypeOptions: MilestoneInjectionTypeOptionType[] = [
  {
    name: 'Direct Voucher',
    value: 'DIRECT_VOUCHER',
  },
  {
    name: 'Next Transaction',
    value: 'NEXT_TRANSACTION',
  },
]

// Global User + Direct Voucher follows the Early User rule: Jumlah Order is auto numbered and locked
export const isDirectVoucherGlobalUser = (form: MilestoneGeneralFormType): boolean =>
  form.milestoneType?.value === 'RETURNING_USER' && form.injectionType?.value === 'DIRECT_VOUCHER'

export const defaultInjectionType: MilestoneInjectionTypeOptionType = injectionTypeOptions[0]

export const backgroundColorOptions = [
  {
    name: 'Biru',
    value: '#0084FF',
  },
  {
    name: 'Cyan',
    value: '#00FFFF',
  },
  {
    name: 'Hijau',
    value: '#00FF00',
  },
  {
    name: 'Ungu',
    value: '#A020F0',
  },
  {
    name: 'Violet',
    value: '#7F00FF',
  },
  {
    name: 'Custom',
    value: 'custom',
  },
]

export const rewardTypeOptions: MilestoneRewardType[] = ['VOUCHER']
